import { createContext, Dispatch, FC, useContext, useState } from 'react'

interface OrderListContextData {
  showOrderFilter: boolean
  setShowOrderFilter: Dispatch<React.SetStateAction<boolean>>
}

export const OrderListContext = createContext<OrderListContextData>(
  {} as OrderListContextData
)

export const OrderListProvider: FC = ({ children }) => {
  const [showOrderFilter, setShowOrderFilter] = useState(false)

  return (
    <OrderListContext.Provider
      value={{
        showOrderFilter,
        setShowOrderFilter
      }}
    >
      {children}
    </OrderListContext.Provider>
  )
}

export function useOrderListContext() {
  return useContext(OrderListContext)
}
